// extracted by mini-css-extract-plugin
export default {"description":"Paragraph_description__shAg0","clickable":"Paragraph_clickable__qDv5z"};